<template>
    <div v-if="showRelateBoard" class="f-topic-related">
        <div :class="{'f-topic-related-fixed': isShowFixed}">
            <!-- 相关issue，仅在topic中展示 -->
            <related-board-item 
                type="issue"
                title="相关问题与需求"
                process-key="process"
                index-key="issueId"
                router-key="issueId"
                v-if="topicType === 2 && issueList.length > 0"
                :list-data="issueList">
            </related-board-item>

            <!-- 帖子相关链接展示，不在issue页面中展示 -->
            <related-board-item
                type="link"
                title="相关链接"
                index-key="id"
                router-key="id"
                v-if="!isIssueType && relatedLinkList.length > 0"
                :list-data="relatedLinkList"
            ></related-board-item>

            <!-- issue相关问题展示，仅在issue中展示 -->
            <related-board-item
                type="topic"
                title="相关问题"
                process-key="createdTime"
                index-key="topicId"
                router-key="topicId"
                v-if="isIssueType && topicList.length > 0"
                :list-data="topicList"
            ></related-board-item>
        </div>
    </div>
</template>

<style lang="less">
    @import '../../../assets/less/views/topic-content/related-board.less';
</style>

<script>
import RelatedBoardItem from './RelatedBoardItem.vue';
import {mapGetters} from 'vuex';
import {getScrollTop} from '@/utils/decorate/scroll';
import {addEvent} from '@/utils/decorate/event';
    
export default {
    components: {
        'related-board-item': RelatedBoardItem
    },
    data() {
        return {
            isShowFixed: false
        };
    },
    computed: {
        ...mapGetters([
            'issueList',
            'relatedLinkList',
            'topicList',
            'topicType',
            'isIssueType',
            'showRelateBoard',
            'headerHeightChange'
        ])
    },
    mounted() {
        // 根据头部高度，确认右侧相关链接fixed显示的时机
        const issueHeaderHeight = this.headerHeightChange ? 140 : 120;
        // 获取滚动高度，右侧相关板块是否fixed显示
        addEvent(window, 'scroll', () => {
            const scrollTop = getScrollTop();
            this.isShowFixed = scrollTop > issueHeaderHeight;
        });
    }
};
</script>